import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

const ClientInformation = ({ locals }) => {
  const { athlete } = locals;

  const [completedWorkouts, setCompletedWorkouts] = useState({
    lastCompletedDate: "-",
    completedWorkoutsCount: 0,
  });

  useEffect(() => {
    if (locals?.activeExercises) {
      // honestly could do without the useEffect but we're using react so why not
      const result = analyzeWorkouts(locals?.activeExercises);

      setCompletedWorkouts(result);
    }
  }, [locals?.activeExercises]);

  const checkInDates = locals?.dailyStats
    ?.filter((stat) => !!stat.questionnaire)
    .sort((a, b) => b.utcDate - a.utcDate);

  return (
    <article className="client-information">
      <p className="s1">Client Information</p>

      <div className="info-row">
        <p className="p5">Client since date</p>
        <p className="p1">{moment(athlete?.joinedAt).format("MMM D, YYYY")}</p>
      </div>
      <div className="info-row">
        <p className="p5">Last check-in</p>
        <p className="p1">
          {checkInDates.length > 0
            ? moment(checkInDates[0].utcDate, "YYYYMMDD").format("MMM D, YYYY")
            : "-"}
        </p>
      </div>
      <div className="info-row">
        <p className="p5">Last coach video sent</p>
        <p className="p1">
          {locals?.coachVideos?.length > 0
            ? moment(locals?.coachVideos[0].date).format("MMM D, YYYY")
            : "-"}
        </p>
      </div>
      <div className="info-row">
        <p className="p5">Last workout completed</p>
        <p className="p1">{completedWorkouts.lastCompletedDate}</p>
      </div>
      <div className="info-row">
        <p className="p5">Completed workouts in the last 30 days</p>
        <p className="p1">{completedWorkouts.completedWorkoutsCount || "-"}</p>
      </div>
    </article>
  );
};

const analyzeWorkouts = (exercises) => {
  // Group exercises by date
  const groupedByDate = exercises.reduce((acc, exercise) => {
    acc[exercise.utcDate] = acc[exercise.utcDate] || [];
    acc[exercise.utcDate].push(exercise);
    return acc;
  }, {});

  let completedWorkoutsCount = 0;
  let lastCompletedDate = null;

  for (const [date, exercises] of Object.entries(groupedByDate)) {
    const oneExerciseCompleted = exercises.some((exercise) => {
      return exercise.sets.some((set) => {
        // Check if there are outcomes and whether if any of them are completed
        if (!set.outcomes) return false;
        return Object.values(set.outcomes).some(
          (outcome) => outcome.status === "completed"
        );
      });
    });

    // Get the date and number of workouts
    if (oneExerciseCompleted) {
      completedWorkoutsCount++;
      if (!lastCompletedDate || +date > +lastCompletedDate) {
        lastCompletedDate = date;
      }
    }
  }

  return {
    lastCompletedDate: lastCompletedDate
      ? moment(lastCompletedDate).format("MMM D, YYYY")
      : "-",
    completedWorkoutsCount,
  };
};

ClientInformation.propTypes = {
  locals: PropTypes.any,
};

export default ClientInformation;
